import Navbar from "../../components/navbar/navbar";
import "./register.css";
import RegisterComponent from "../../components/RegisterComponent/registerComponent";
import Footer from "../../components/Footer/Footer";

function Register() {
  return (
    <>
      <Navbar active="Sign Up"></Navbar>
      <section className="register-page-bg">
        <RegisterComponent />
      </section>
      <Footer />
    </>
  );
}

export default Register;
